import {
  AUTOMATION_DELETE,
  AUTOMATION_EXISTING_TRIGGERS,
  AUTOMATION_STATS,
  AUTOMATION_TRIGGERS,
  AUTOMATION_VERIFIED_STATS,
  COMPLETIONS,
  EMAIL_ACCOUNTS_TEST,
} from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';
import * as queryString from 'query-string';
import { Pagination } from '../store-interfaces';

export type CampaignResourcePayload = {
  success: boolean;
  errors: any[];
};

export type CreateInputTriggerParams = {
  botId: number;
  campaignId: number;
  templateParams: Record<any, any>;
};

export type DeleteAutomationParams = {
  id: number;
  destroyAll?: boolean;
  destroyPages?: boolean;
  destroyTriggers?: boolean;
  deactivateTriggers?: boolean;
};

export type EmailAnalyticsParams = {
  botId: number;
  widgetDataEmailId: number;
} & Pick<Pagination, 'page' | 'perPage'>;

export type AutomationVerifiedStatsType = {
  verifiedStats: {
    verifiedEmailsCount: number;
    totalEmailsCount: number;
    notVerifiedEmailsCount: number;
    suppressedCount: number;
  };
};

export default class AutomationController extends AuthenticatedController {
  static getVerifiedStats(
    campaignId: number = -1,
  ): Promise<AutomationVerifiedStatsType> {
    return super.get(AUTOMATION_VERIFIED_STATS(campaignId));
  }

  // Note: returns aggregate stats if no campain_id is provided
  static getStats(botId: number, campaignId?: number) {
    const query = queryString.stringify({
      bot_id: botId,
      campaign_id: campaignId,
    });
    return super.get(`${AUTOMATION_STATS}?${query}`);
  }

  static getExistingInputTriggers(botId: number) {
    const query = queryString.stringify({
      bot_id: botId,
    });
    return super.get(`${AUTOMATION_EXISTING_TRIGGERS}?${query}`);
  }

  static createInputTrigger(params: CreateInputTriggerParams) {
    return super.post(AUTOMATION_TRIGGERS, params);
  }

  static sendTestEmail(params: {
    emails: string[];
    facebookPageId: number;
    widgetId: number;
    body: string;
    subject: string;
    preview: string;
    emailAttachments?: { id: number }[];
  }) {
    return super.post(EMAIL_ACCOUNTS_TEST, params);
  }

  static getEmailCompletion(
    facebookPageId: number,
    content: {
      urlFromForm?: string;
      companyInfoFromForm?: string;
      rewriteEmailBody?: string;
    } = { urlFromForm: '', companyInfoFromForm: '' },
  ): Promise<{ completions: string[] }> {
    return super.post(COMPLETIONS(facebookPageId), { content });
  }

  static deleteAutomation(params: DeleteAutomationParams) {
    const { id, ...rest } = params;
    return super.delete(AUTOMATION_DELETE(id), null, undefined, rest);
  }
}
